import { useApexApiReq } from '@hooks/useApex';

interface getExperimentConfigurationProps {
  policyProcessId: string;
  experimentKey: string[];
  userAgent: string;
}

export interface getExperimentConfigurationResponse {
  activatedExperiments: Array<experimentConfigurationInformation>;
}

interface variantConfiguration {
  variantConfigurationName: string;
  variantConfigurationType: string;
  variantConfigurationValue: string;
}

interface experimentConfiguration {
  experimentConfigurationName: string;
  experimentConfigurationType: string;
  experimentConfigurationValue: string;
}

interface experimentConfigurationInformation {
  experimentId: string;
  experimentKey: string;
  experimentName: string;
  variationId: string;
  variationName?: string;
  isHoldOut: boolean | null;
  isAudienceQualified: boolean | null;
  variantConfiguration: Array<variantConfiguration> | null;
  experimentConfiguration: Array<experimentConfiguration> | null;
  errorMessage?: string;
}

export const useGetExperimentConfiguration = ({
  policyProcessId,
  experimentKey,
  userAgent,
}: getExperimentConfigurationProps) => {
  const getExperimentConfigurationOptions = {
    method: 'POST',
    headers: {
      'Airkey-Version': '1',
      Accept: 'applicaton/json; v=1',
      'content-type': 'application/json',
      'User-Agent': userAgent,
    },
    body: JSON.stringify({
      experimentKey,
    }),
  };

  return useApexApiReq<getExperimentConfigurationResponse>({
    url: `/protected/1066746/3dsecure/${policyProcessId}/experiment-configuration`,
    options: getExperimentConfigurationOptions,
  });
};
